<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/cases/` : "/api/cases/"
const { data } = await useFetch(apiUrl, { key: "home-cases" })

const resolveImageUrl = (url) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/media/")) return url
  return url
}

const sectionData = computed(() => data.value?.section || null)
const items = computed(() => (data.value?.items?.length ? data.value.items : []))

const rows = computed(() => {
  const grouped = new Map()
  items.value.forEach((item) => {
    const row = item.row || 1
    if (!grouped.has(row)) grouped.set(row, [])
    grouped.get(row).push(item)
  })
  return Array.from(grouped.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([, list]) => list)
})
</script>

<template>
  <section v-if="sectionData" class="section-cases">
    <h4 style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);">
      {{ sectionData.title }}
    </h4>
    <div class="cases__container">
      <div v-for="(rowItems, idx) in rows" :key="idx" class="cases__container__row">
        <div v-for="item in rowItems" :key="item.id" class="cases-item"
             style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1;">
          <img :src="resolveImageUrl(item.image_url)" loading="lazy" :alt="item.alt" class="image-cover">
        </div>
      </div>
    </div>
    <div id="clients" class="scroll-anchor"></div>
  </section>
</template>

<style lang="scss" scoped>
@use '/assets/scss/sections/_cases.scss';
</style>
